import React, { Component } from 'react';
import { Link } from 'react-router';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

import './projectList.css';

class ProjectList extends Component {

  constructor(props) {
    super()
    this.props = props
  }

  randomNum = () => {
    return Math.random();
  }

  render() {
    return (
      <div className="project-list">
       <Dropdown>
        <DropdownTrigger>Works</DropdownTrigger>
          <DropdownContent>
            {
              this.props.projects.map(function(project) {
                return(
                  <Link to={`/${project.slug}`} key={this.randomNum()} className="project-list-item">{project.name}</Link>
                )
              }.bind(this))
            }
          </DropdownContent>
        </Dropdown>
       </div> 
    );
  }
}

export default ProjectList;


/** WEBPACK FOOTER **
 ** ./src/js/components/projectList/index.js
 **/